import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LessPennyService } from '_services/lesspenny.service';

@Component({
  selector: 'app-advertisers-detail',
  templateUrl: './advertisers-detail.component.html',
  styleUrls: ['./advertisers-detail.component.css']
})
export class AdvertisersDetailComponent implements OnInit {

  constructor(private lesspennyService: LessPennyService,
    private activeRoute: ActivatedRoute) {
    this.activeRoute.params.subscribe(params => {
      if (params['advFriendlyName']) {
        console.log(params['advFriendlyName']);
        // this.dataService.getChartsData(params['id'])
        //     .subscribe(data => console.log(data));
      }
    })
  }

  ngOnInit() {
  }

}
